import React from "react";
import VendorComparisonTable from "./vendor-comparison-table";
import { DATADOG_FEATURE_TABLE_ROWS } from "./datadog-comparison-data";

type Props = {
  className?: string;
};

const DATADOG_BRAND = {
  name: "Datadog",
  logoSrc: "/images/datadog_logo.svg",
  logoAlt: "Datadog Logo",
  cellLogoSrc: "/images/datadog_logo.svg",
  cellLogoWidth: 72,
  cellLogoHeight: 22,
  headerLogoWidth: 119,
  headerLogoHeight: 42,
};

/** @deprecated Prefer VendorComparisonTable with vendor data props */
const DatadogComparisonTable: React.FC<Props> = ({ className = "" }) => (
  <VendorComparisonTable
    className={className}
    rows={DATADOG_FEATURE_TABLE_ROWS}
    competitor={DATADOG_BRAND}
  />
);

export default DatadogComparisonTable;
